import PictureViewer from "@/components/common/PictureViewer";
import { myIcons } from "@/utils/icons"
import "./style.css";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import i18next from "i18next";

const images = [
    "/assets/pictures/deriner1.jpg",
    "/assets/pictures/deriner2.jpg",
];

export const Experiences = () => {

    const { t } = useTranslation();
    const experiencesList = {
        "euas": {
            icon: myIcons.experiences.euas,
            title: "Elektrik Üretim A.Ş.",
            workplace: t("euas-workplace"),
            time: t('euas-time'),
            departments: [
                {
                    subTitle: t('euas-department1-subtitle'),
                    time: t('euas-department1-time'),
                    description: t('euas-department1-desc'),
                },
                {
                    subTitle: t('euas-department2-subtitle'),
                    time: t('euas-department2-time'),
                    description: t('euas-department2-desc'),
                },
                {
                    subTitle: t('euas-department3-subtitle'),
                    time: t('euas-department3-time'),
                    description: t('euas-department3-desc'),
                },

            ]
        },
        "coruh": {
            icon: myIcons.experiences.coruh,
            title: "AKSA-Çoruh Elektrik Dağıtım A.Ş.",
            workplace: t("coruh-workplace"),
            time: t('coruh-time'),
            departments: [
                {
                    subTitle: t('coruh-department1-subtitle'),
                    time: t('coruh-department1-time'),
                    description: t('coruh-department1-desc'),
                },
                {
                    subTitle: t('coruh-department2-subtitle'),
                    time: t('coruh-department2-time'),
                    description: t('coruh-department2-desc'),
                },
            ]
        },
    }
    return <div
        style={{ color: 'var(--color-text)', }}
    >
        <p
            style={{
                fontSize: '25px',
                marginBottom: '20px',
            }}
        >{t("experiences-title")}</p>
        {Object.values(experiencesList).map((val, index) => (
            <ExperiencesItem icon={val.icon} title={val.title} workplace={val.workplace} time={val.time} departments={val.departments} />
        ))}
    </div >
}

interface DepartmentsItemPropsI {
    subTitle: string;
    time: string;
    description: string;
}

const DepartmentsItem = ({ subTitle, time, description }: DepartmentsItemPropsI) => {
    return (
        <motion.div
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.1 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
        >
            <div style={{ display: 'flex', flexDirection: 'row', marginTop: '20px' }} >
                <div
                    style={{
                        width: '10px',
                        height: '10px',
                        backgroundColor: '#3f51b5',
                        borderRadius: '100px',
                        flexShrink: 0,
                        marginRight: '20px',
                    }}
                ></div>
                <div style={{ maxWidth: '600px', transform: 'translateY(-5px)', }} >
                    <div style={{ display: 'flex', marginBottom: '5px', gap: '10px' }}>
                        <p style={{ fontWeight: 'bold' }} >{subTitle}</p>
                        <p style={{ color: 'grey' }} >{time}</p>
                    </div>
                    <p>{description}</p>
                </div>
            </div>
        </motion.div >);
}

interface ExperiencesItemPropsI {
    icon: string;
    title: string;
    workplace: string;
    time: string;
    departments: DepartmentsItemPropsI[]
}


const ExperiencesItem = ({ icon, title, workplace, time, departments }: ExperiencesItemPropsI) => {
    const isEuas: boolean = icon == myIcons.experiences.euas;
    return (
        <div className="experiences-item"
            style={{
                display: 'flex',
                gap: '30px',
                marginBottom: '50px',
            }}
        >
            <div
                style={{
                    display: 'flex',
                    backgroundColor: '#dcdcdcff',
                    alignItems: 'center',
                    width: '50px',
                    height: '50px',
                    padding: '5px',
                    borderRadius: '10px',
                    boxShadow: '0 2px 8px rgba(33, 33, 33, 0.5)',
                }}
            >
                <div
                    style={{
                        borderRadius: '5px',
                        overflow: 'hidden',
                        display: 'inline-block',
                    }}
                >
                    <img
                        style={{
                            width: '100%',
                            height: 'auto',
                            objectFit: 'contain',
                            display: 'block',
                        }}
                        src={icon}
                        alt=""
                    />
                </div>

            </div>

            <div>
                <h4>{title}</h4>
                <p>{workplace}</p>
                <p
                    style={{ color: '#9e9e9e', marginBottom: '20px' }}
                >{time}</p>
                <div
                    style={{ display: 'flex', flexDirection: 'row' }}
                >
                    <div style={{
                        width: '10px',
                        backgroundColor: '#dcdcdcff',
                        borderRadius: '100px',
                        flexShrink: 0
                    }} ></div>
                    <div style={{
                        display: 'flex', flexDirection: 'column', gap: '30px', transform: 'translateX(-10px)'
                    }}>

                        {departments.map((val, index) => (
                            <DepartmentsItem
                                key={index}
                                subTitle={val.subTitle}
                                time={val.time}
                                description={val.description}
                            />
                        ))}

                        <div style={{
                            display: isEuas ? 'flex' : 'none',
                            gap: '10px',
                            marginLeft: '30px'
                        }}>
                            <PictureViewer images={images} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}